import React, {FC} from "react";
import {ThemeProvider} from "styled-components";
import {ThemeProvider as ThemeProviderNative} from "styled-components/native";
import {useSelector} from "react-redux";
import {IState} from "@fkhplus/common/src/modules/interfaces";

const RootTheme: FC = ({children}) => {
    const theme = useSelector((state: IState) => state.theme.theme);
    return (
        <ThemeProvider theme={theme}>
            <ThemeProviderNative theme={theme}>
                {children}
            </ThemeProviderNative>
        </ThemeProvider>
    )
}

export default RootTheme;